import {formsApiHostName} from "../endpoint";
import {defaultHeaders} from "../headers";

export const getAllTemplates = async (categoryName) => {
  try {
    const result = await fetch(
      `${formsApiHostName}/templates/${categoryName}`,
      {
        method: "GET",
        headers: {
          ...defaultHeaders,
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      }
    );
    return {
      hasSuccess: result.status === 200,
      data: await result.json(),
    };
  } catch (error) {
    return {
      hasSuccess: false,
      data: error.message,
    };
  }
};
